export type SiteMode = 'main' | 'merchant' | 'admin';

export function getSiteMode(): SiteMode {
  const site = process.env.REACT_APP_SITE;
  if (site === 'main' || site === 'merchant' || site === 'admin') {
    return site;
  }
  return 'main';
}
